export default __webpack_public_path__ + "static/media/movistar.7b4a3e75.svg";